module.exports = __webpack_public_path__ + "img/TrustServiceCategor9.71884649.jpg";